import * as React from "react";
const InstallationSelectionView = React.lazy(() => import("./InstallationSelectionViewContainer"));
const InstallationsSelectionView = React.lazy(() => import("./InstallationsSelectionViewContainer"));

export { InstallationSelectionView };
export { InstallationsSelectionView };
